module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/工作站-应用场景2.63c7ac00.png";